import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../../../components/card/card.jsx";
import Chart from "react-apexcharts";
import React, { useState, useEffect } from "react";
import { dashboard } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

function TopCards({ onClick, onStatusClick }) {
  const {
    selectedLocationOverview,
    selectedMachineOverview,
    dateRangeOverview,
  } = useDashboardContext();
  const navigate = useNavigate();
  const { config } = useAuth();
  const roleItem = config?.RoleCompanyMaster[0]?.feature_access;
  const showCost = roleItem?.find((item) => item === "Show Cost");
  const [pieData, setPieData] = useState(null);
  const [pieDataMachine, setPieDataMachine] = useState(null);
  const [totalCostSaved, setTotalCostSaved] = useState(0);
  const [totalDowntimeAvoided, setTotalDowntimeAvoided] = useState(0);
  const [totalManpowerSaved, setTotalManpowerSaved] = useState(0);
  async function fetchData() {
    const result = await dashboard.aletStatus({
      location_id: selectedLocationOverview ? selectedLocationOverview : "",
      machine_id: selectedMachineOverview ? selectedMachineOverview : "",
      start_date: dateRangeOverview?.startDate
        ? dateRangeOverview?.startDate
        : "",
      end_date: dateRangeOverview?.endDate ? dateRangeOverview?.endDate : "",
    });
    const data = await parserAPI(result);
    let open = data.find((s) => s.status === "Open")?.count || 0;
    let closed = data.find((s) => s.status === "Closed")?.count || 0;
    let invalid = data.find((s) => s.status === "Invalid")?.count || 0;
    let progress = data.find((s) => s.status === "In Progress")?.count || 0;
    setPieData([open, closed, invalid, progress]);
  }
  async function fetchMachineData() {
    const result = await dashboard.machineHealthSelf({
      location_id: selectedLocationOverview ? selectedLocationOverview : "",
      machine_id: selectedMachineOverview ? selectedMachineOverview : "",
    });
    const data = await parserAPI(result);
    let acceptable = data.find((s) => s.status === "Acceptable")?.count || 0;
    let observe = data.find((s) => s.status === "Observe")?.count || 0;
    let alert = data.find((s) => s.status === "Alert")?.count || 0;
    let critical = data.find((s) => s.status === "Critical")?.count || 0;
    setPieDataMachine([acceptable, observe, alert, critical]);
  }
  async function fetchAnalytics() {
    const result = await dashboard.alertAnalyticCostManpower();
    const data = await parserAPI(result);
    setTotalCostSaved(data.maintenance_cost);
    setTotalDowntimeAvoided(data.unplanned_downtime);
    setTotalManpowerSaved(data.man_hour_saved);
  }
  useEffect(() => {
    fetchData();
    fetchMachineData();
    fetchAnalytics();
  }, [selectedLocationOverview, selectedMachineOverview, dateRangeOverview]);
  const sampleData = [5, 4, 3];
  const sampleDataCritical = [5, 4, 3, 1];
  const sampleDataLine = [
    {
      name: "Downtime",
      data: [81, 89, 71, 75, 53, 47, 78, 33, 71, 81, 45, 43, 68],
    },
  ];
  const sableBarData = [
    {
      name: "Cost Saved",
      data: [69, 34, 70, 73, 41, 32, 73, 72, 89, 57, 42, 86, 78],
    },
  ];
  function getChartOptions() {
    var themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();
    var themeColorRgb = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme-rgb")
      .trim();

    return {
      bar: {
        colors: [themeColor],
        chart: { sparkline: { enabled: true } },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
      line: {
        colors: [themeColor],
        chart: { sparkline: { enabled: true } },
        stroke: { curve: "straight", width: 2 },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
      pie: {
        colors: [
          "rgba(195, 111, 130, 1)",
          "rgba(185,186,188, 1)",
          "rgb(121,121,121)",
          "rgba(249,220,142, 1)",
        ],
        chart: {
          sparkline: { enabled: true },
          events: {
            click: function (event, chartContext, { dataPointIndex }) {
              const datas = ["Open", "Closed", "Invalid", "In Progress"];
              // navigate("/alarm/list", {
              //   state: { status: datas[dataPointIndex] },
              // });
              onStatusClick(datas[dataPointIndex]);
            },
          },
        },
        stroke: { show: false },
        tooltip: {
          x: { show: true },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
      pieMachine: {
        colors: [
          "rgb(175,234,205)",
          "rgba(249,220,142, 1)",
          "rgba(255,190,127, 1)",
          "rgba(255, 119, 156, 1)",
        ],
        chart: {
          sparkline: { enabled: true },
          events: {
            click: function (event, chartContext, { dataPointIndex }) {
              console.log("click");
              console.log({ dataPointIndex, event, chartContext });
              const datas = ["Acceptable", "Observe", "Alert", "Critical"];
              onClick(datas[dataPointIndex]);
              // navigate("/machine-health", {
              //   state: { status: datas[dataPointIndex] },
              // });
            },
          },
        },

        stroke: { show: false },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
      donut: {
        colors: [
          "rgba(" + themeColorRgb + ", .15)",
          "rgba(" + themeColorRgb + ", .35)",
          "rgba(" + themeColorRgb + ", .55)",
          "rgba(" + themeColorRgb + ", .75)",
          "rgba(" + themeColorRgb + ", .95)",
        ],
        chart: { sparkline: { enabled: true } },
        stroke: { show: false },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: function (seriesName) {
                return "";
              },
            },
          },
        },
      },
    };
  }
  const [chartOptions, setChartOptions] = useState(getChartOptions());
  return (
    <div className="row">
      <div className={showCost ? `col-xl-3 col-lg-6` : "col-xl-6"}>
        <Card className="mb-3">
          <CardBody style={{ minHeight: "184px" }}>
            <div className="d-flex fw-bold small mb-3">
              <span className="flex-grow-1">Total Alarm</span>
              <CardExpandToggler />
            </div>
            <div className="row align-items-center mb-2">
              <div className="col-7">
                <h3 className="mb-1">
                  {" "}
                  {pieData && pieData.reduce((a, b) => a + b, 0)}
                </h3>
                <div className="small text-inverse text-opacity-75 text-truncate">
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-open"></div>{" "}
                    <div>{pieData ? pieData[0] : 0} - Open </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-closed"></div>{" "}
                    <div>{pieData ? pieData[1] : 0} - Closed </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-invalid"></div>{" "}
                    <div>{pieData ? pieData[2] : 0} - Invalid </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-progress"></div>{" "}
                    <div>{pieData ? pieData[3] : 0} - In-Progress </div>
                  </div>
                </div>
              </div>
              <div className="col-5">
                <div className="mt-n2" style={{ cursor: "pointer" }}>
                  {pieData && (
                    <Chart
                      type="pie"
                      height={"auto"}
                      width={"100%"}
                      options={chartOptions["pie"]}
                      series={pieData}
                    />
                  )}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
      <div className={showCost ? `col-xl-3 col-lg-6` : "col-xl-6"}>
        <Card className="mb-3">
          <CardBody style={{ minHeight: "184px" }}>
            <div className="d-flex fw-bold small mb-3">
              <span className="flex-grow-1">Machine Health</span>
              <CardExpandToggler />
            </div>
            <div className="row align-items-center mb-2">
              <div className="col-7">
                <h3 className="mb-1">
                  {pieDataMachine && pieDataMachine.reduce((a, b) => a + b, 0)}
                </h3>
                <div className="small text-inverse text-opacity-75 text-truncate">
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-accept"></div>{" "}
                    <div>
                      {pieDataMachine ? pieDataMachine[0] : 0} - Acceptable{" "}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-observe"></div>{" "}
                    <div>
                      {pieDataMachine ? pieDataMachine[1] : 0} - Observe{" "}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-alert"></div>{" "}
                    <div>{pieDataMachine ? pieDataMachine[2] : 0} - Alert </div>
                  </div>
                  <div className="d-flex">
                    <div className="list-alert-dashboard bg-critical"></div>{" "}
                    <div>
                      {pieDataMachine ? pieDataMachine[3] : 0} - Critical{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-5">
                <div className="mt-n2" style={{ cursor: "pointer" }}>
                  {pieDataMachine && (
                    <Chart
                      type="pie"
                      height={"auto"}
                      width={"100%"}
                      options={chartOptions["pieMachine"]}
                      series={pieDataMachine}
                    />
                  )}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
      {showCost && (
        <div className="col-xl-3 col-lg-6">
          <Card className="mb-3">
            <CardBody style={{ minHeight: "184px" }}>
              <div className="d-flex fw-bold small mb-1">
                <span className="flex-grow-1">
                  Total Unplanned Downtime Avoided
                </span>
              </div>
              <div className="row align-items-center mb-2">
                <div className="col-7">
                  <h3 className="mb-1">{totalDowntimeAvoided} Hrs</h3>
                </div>
                <div className="col-5">
                  <div className="mt-n2">
                    <Chart
                      type="line"
                      height={30}
                      width={"100%"}
                      options={chartOptions["line"]}
                      series={sampleDataLine}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex fw-bold small mb-1">
                <span className="flex-grow-1">Total Manhour Saved</span>
              </div>
              <div className="row align-items-center mb-2">
                <div className="col-7">
                  <h3 className="mb-1">{totalManpowerSaved} Hrs</h3>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      )}
      {showCost && (
        <div className="col-xl-3 col-lg-6">
          <Card className="mb-3">
            <CardBody style={{ minHeight: "184px" }}>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1">Total Cost Saved</span>
                <CardExpandToggler />
              </div>
              <div className="row align-items-center mb-2">
                <div className="col-7">
                  <h3 className="mb-1">
                    {totalCostSaved} {config?.currency_symbol}{" "}
                  </h3>
                </div>
                <div className="col-5">
                  <div className="mt-n2">
                    <Chart
                      type="bar"
                      height={30}
                      width={"100%"}
                      options={chartOptions["bar"]}
                      series={sableBarData}
                    />
                  </div>
                </div>
              </div>
              <div className="small text-inverse text-opacity-50 ">
                <i className="fa fa-info-circle"></i> Based on Cost saved in
                Closed Alarm
              </div>
            </CardBody>
          </Card>
        </div>
      )}
    </div>
  );
}

export default TopCards;
